import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    template: `
    <div class="closePopupImg">
      <button class="btn btn-primary close-comment-button" mat-dialog-close>
        <img  src="../../../../../assets/icons/close-white.svg" width="100%">
      </button>
    </div>
    <div class="commentContent">
      @if (_data&&_data.length>0) {
        @for (item of _data; track item) {
          <div class="AdminCommentPopup" >[{{item?.creationDate | date:'dd-MM-yyyy'}}]{{item?.author?.uid}}&nbsp;:&nbsp;{{item?.text}}</div>
        }
      } @else {
        <b> No Comments Found</b>
      }
    </div>
    `,
    styleUrls: ['./brake-admin-search-form.component.scss'],
    standalone: false
})
export class adminsearchCommentPopup {
    constructor(@Inject(MAT_DIALOG_DATA) public _data: any) {
    }
}